import {BaseComponent, SimpleShouldUpdate} from "react-vextensions";
import {VReactMarkdown, PageContainer} from "web-vcore";
import React from "react";
import {styles} from "../../Utils/UI/GlobalStyles.js";

const pageText = `
TODO
`;

export const AboutUI = (()=>{
	return (
		<PageContainer scrollable={true} style={styles.pageContainer}>
			<article className="selectable">
				<VReactMarkdown source={pageText}
					/*markdownOptions={{breaks: false}} rendererOptions={{breaks: false}}
					rendererOptions={{
						components: {
							br: ()=><span> </span>
						}
					}}*/
					/*renderers={{
						Text: props=> {
							return <span style={{color: "rgba(255,255,255,.7)"}}>{props.literal}</span>;
						}
					}}*/
				/>
			</article>
		</PageContainer>
	);
});